import React from "react";
import Slide from "../Slider/Slide";
import "./OpinionStd.css";

const OpinionStd = () => {
  return (
    <div>
      <Slide></Slide>
    </div>
  );
};

export default OpinionStd;
